import {inject} from 'vue';

/**
 * `inject()` requires an active component instance, so this must be called
 * synchronously during a component's `setup()` (e.g. at the top of a composable
 * like `useAuth()`) — not stored/invoked later, and not called at module scope.
 */
export function useSwalMessage() {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   const swal = inject<(config: Record<string, any>) => void>('$swal');

   return (icon: string, title: string, timer = 1500) => {
      if (swal) {
         swal({
            icon,
            title,
            showConfirmButton: false,
            timer,
         });
      }
   };
}
